import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { LocalStorageService } from "./utility/localStorageService";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {

  constructor(private storage: LocalStorageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Bypass login API
    if (req.url.includes('/login') || req.url.includes('/auth')) {
      return next.handle(req);
    }

    let token = this.storage.get("token");
    let platform = this.storage.get("OS") === "Android" ? "App" : "Web";

    let userId = this.storage.get("refNo") ?? "New Login";
    let method = this.storage.get("method") ?? "GET";
    let operation = this.storage.get("operation") ?? "Accessing Login Page";

    const modifiedReq = req.clone({
      setHeaders: {
        platform: platform,
        byUser: userId,
        method: method,
        operation: operation,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'X_Correlation_Id': this.generateUUID(),
        'Content-Type': "application/json"
      }
    });

    return next.handle(modifiedReq);
  }

  private generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0;
      const v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}
